import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
    createLabEquipmentSuccess, createLabEquipmentFailure,
    getAllLabEquipmentSuccess, getAllLabEquipmentFailure,
    getByIdLabEquipmentSuccess, getByIdLabEquipmentFailure,
    updateLabEquipmentSuccess, updateLabEquipmentFailure,
    addMaintenanceSuccess, addMaintenanceFailure,
    addCalibrationSuccess, addCalibrationFailure,
    addDowntimeSuccess, addDowntimeFailure,
} from './slice';
import requestHandler from '../../../../utils/requestHandler';
import { logoutRequest } from '../../auth/authSlice';

function* createRequest(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "POST",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json", "X-Current-Branch": currentBranch.id },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/equipment`, requestDetail);
        yield put(createLabEquipmentSuccess(response));
    } catch (error) { yield put(createLabEquipmentFailure(error?.response?.message || error)); }
}

function* getAllRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        let url = `${process.env.REACT_APP_SERVER_API}api/laboratory/equipment`;
        const params = action.payload || {};
        const queryParts = [];
        if (params.departmentId) queryParts.push(`departmentId=${params.departmentId}`);
        if (params.status) queryParts.push(`status=${params.status}`);
        if (queryParts.length) url += `?${queryParts.join('&')}`;
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, url, requestDetail);
        yield put(getAllLabEquipmentSuccess(response));
    } catch (error) { yield put(getAllLabEquipmentFailure(error?.response?.message || error)); }
}

function* getByIdRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/equipment/${action.payload}`, requestDetail);
        yield put(getByIdLabEquipmentSuccess(response));
    } catch (error) { yield put(getByIdLabEquipmentFailure(error?.response?.message || error)); }
}

function* updateRequest(action) {
    try {
        const requestDetail = {
            method: "PUT",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/equipment`, requestDetail);
        yield put(updateLabEquipmentSuccess(response));
    } catch (error) { yield put(updateLabEquipmentFailure(error?.response?.message || error)); }
}

function* maintenanceRequest(action) {
    try {
        const { id, ...body } = action.payload;
        const requestDetail = {
            method: "POST",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify(body)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/equipment/${id}/maintenance`, requestDetail);
        yield put(addMaintenanceSuccess(response));
    } catch (error) { yield put(addMaintenanceFailure(error?.response?.message || error)); }
}

function* calibrationRequest(action) {
    try {
        const { id, ...body } = action.payload;
        const requestDetail = {
            method: "POST",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify(body)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/equipment/${id}/calibration`, requestDetail);
        yield put(addCalibrationSuccess(response));
    } catch (error) { yield put(addCalibrationFailure(error?.response?.message || error)); }
}

function* downtimeRequest(action) {
    try {
        const { id, ...body } = action.payload;
        const requestDetail = {
            method: "POST",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify(body)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/equipment/${id}/downtime`, requestDetail);
        yield put(addDowntimeSuccess(response));
    } catch (error) { yield put(addDowntimeFailure(error?.response?.message || error)); }
}

function* saga() {
    yield takeLatest('labEquipment/createLabEquipmentRequest', createRequest);
    yield takeLatest('labEquipment/getAllLabEquipmentRequest', getAllRequest);
    yield takeLatest('labEquipment/getByIdLabEquipmentRequest', getByIdRequest);
    yield takeLatest('labEquipment/updateLabEquipmentRequest', updateRequest);
    yield takeLatest('labEquipment/addMaintenanceRequest', maintenanceRequest);
    yield takeLatest('labEquipment/addCalibrationRequest', calibrationRequest);
    yield takeLatest('labEquipment/addDowntimeRequest', downtimeRequest);
}

export default saga;
